module.exports = __webpack_public_path__ + "img/jiguang.7cf45ee6.png";